import MemLearning from '@memrise/memlearning';
import { SessionState } from 'src/api/learningSessions/types';
import { convertCardFromMemLearning } from './conversion';

export type SetSessionState = (state: Partial<SessionState>) => void;
export type PresentSummary = (state: {
  endOfSessionPoints: number;
}) => void;

class Presenter {
  constructor(
    private _setState: SetSessionState,
    private _presentSummary: PresentSummary,
  ) { }

  presentLoading() {
    const hookState = { kind: 'LoadingState' } as SessionState;
    this._setState(hookState);
  }

  presentCard(
    card: MemLearning.com.memrise.learning.session.LearnableCard,
    sessionProgress: MemLearning.com.memrise.learning.models.SessionProgress,
  ): void {
    const hookState = convertCardFromMemLearning(card, sessionProgress);
    this._setState(hookState);
  }

  presentSummary(summaryStats: MemLearning.com.memrise.learning.session.SummaryStats): void {
    const endOfSessionPoints = summaryStats.bonusPoints;
    this._presentSummary({ endOfSessionPoints });
  }

  /* istanbul ignore next: not used on web at the moment */
  presentTimer() {
    /* do nothing */
  }

  /* istanbul ignore next: not used on web at the moment */
  presentLives() {
    /* do nothing */
  }
}

export const makePresenter = ({
  setState,
  presentSummary,
}: {
  setState: SetSessionState;
  presentSummary: PresentSummary;
}) => new Presenter(setState, presentSummary);
